import { Collapse, Input, Upload } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AutoCompleteSearch from "../../../common/components/AutoComplete/AutoCompleteSearch";
import EditableFormInput from "../../../common/components/EditableText/EditableFormInput";
import { RedRequiredCircleSVG } from "../../../common/components/icons/SVGIcon";
import ScrollWrapper from "../../../common/components/ScrollBar";
import ToastMessage from "../../../common/components/Toast";
import { validateField } from "../../../services/validations";
import { getPending, save_quick_register, searchPcpNpe, setGlobalLoading } from "../../../store/actions";
import InsuranceDetail from "./InsuranceDetail";

const { TextArea } = Input;
const { Panel } = Collapse;
let timer = null;

const QuickRegister = () => {
  const conditions = useSelector((state) => state.common.referralConditions);
  const pcpDataRef = useSelector((state) => state.newPatient?.pcpDataRef);
  const loadingSearchPCP = useSelector((state) => state.newPatient?.loadingSearchPCP);
  const [dataPCPRef, setDataPCPRef] = useState([]);

  const dispatch = useDispatch();

  const [patient, setPatient] = useState({});
  const [image, setImage] = useState(null);
  const [error, setError] = useState(false);
  const [isToastr, setIsToastr] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [activePannel, setActivePannel] = useState("");
  const [localLoading, setLocalLoading] = useState(false);
  const [disableSearchIcon, setDisableSearchIcon] = useState(false);
  const [resetValue, setResetValue] = useState(false);
  const [valueInsurance, setValueInsurance] = useState([]);

  useEffect(() => {
    setDataPCPRef(pcpDataRef);
  }, [pcpDataRef]);

  const uploadProps = useMemo(() => {
    return {
      onRemove: (file) => {
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
      },
      beforeUpload: (file) => {
        setImage(file);
        return false;
      },
    };
  }, []);

  const handleInput = (type) => (value) => {
    const updates = { ...patient, [type]: value };
    setPatient(updates);
    setError(false);
  };

  const handleChangeOptions = (type) => (get) => {
    let value = "";
    if (type === "notes") {
      value = get.target?.value;
    } else if (type === "referral_provider") {
      setDisableSearchIcon(true);
      let name = "";
      let id = "";
      const slpitValue = get.split(" - ");
      name = slpitValue[0] || "";
      id = slpitValue[1] || "";
      value = id;
    } else {
      value = get;
    }
    const updates = { ...patient, [type]: value || "" };
    setPatient(updates);
    setError(false);
  };

  const onRegister = async () => {
    if (
      validateField("text", patient?.first_name) ||
      validateField("text", patient?.last_name) ||
      validateField("date", patient?.date_of_birth) ||
      validateField("phone", patient?.phone) ||
      validateField("text", patient?.zipcode) ||
      validateField("text", patient?.referral_condition) ||
      validateField("text", patient["referral_provider"]) ||
      validateField("text", patient?.gender) ||
      validateField("date", patient["referral_date"])
    ) {
      setError(true);
      setActivePannel("register");
    } else {
      setError(false);
      const formData = new FormData();
      valueInsurance.map((insurance, index) => {
        formData.append("insurances[]", JSON.stringify(insurance));
      });
      formData.append("first_name", patient?.first_name);
      formData.append("last_name", patient?.last_name);
      formData.append("date_of_birth", patient?.date_of_birth);
      formData.append("phone", patient?.phone);
      formData.append("zipcode", patient?.zipcode);
      formData.append("referral_condition", patient?.referral_condition);
      formData.append("referral_provider", patient?.referral_provider);
      formData.append("referral_date", patient?.referral_date);
      formData.append("notes", patient?.notes);
      formData.append("gender", patient?.gender);
      formData.append("profile_image", image);
      formData.append("ssn", patient?.ssn);
      formData.append("address", patient?.address);
      formData.append("apt_number", patient?.apt_number);
      formData.append("appointment_type_id", patient?.appointment_type_id);
      formData.append("provider_id", patient?.provider_id);
      formData.append("urgency", patient?.urgency);
      await dispatch(setGlobalLoading(true));
      const saveAll = await dispatch(save_quick_register(formData));
      if (saveAll) {
        setPatient({});
        await setResetValue(true);
        await setResetValue(false);
        setValueInsurance([]);
        setImage(null);
        setIsToastr(true);
        dispatch(setGlobalLoading(false));
        dispatch(getPending({}));
        setTimeout(() => {
          setIsToastr(false);
        }, 2000);
      } else {
        alert("save not Success please try again!");
      }
    }
  };

  const fetchSearch = async (value) => {
    if (!value) {
      setDisableSearchIcon(false);
    }
    setLocalLoading(true);
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const getDetailSuccess = await dispatch(searchPcpNpe(1, value));
      if (getDetailSuccess) {
        setLocalLoading(false);
      }
    }, 500);
  };

  const setPropsInsurance = useCallback((value) => {
    setValueInsurance(value || []);
  }, []);

  return (
    <>
      <div
        className="QuickRegister"
        style={{
          width: "100%",
          height: "100%",
          marginTop: "0",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        {isToastr ? <ToastMessage type="Quick Register" status="success" msg="Registered new patient Successfully!" /> : null}
        <div className="fullContainer" style={{ width: "100%", padding: 0, marginTop: "0px", flex: 1 }}>
          <ScrollWrapper css={"no-padding x-hidden"}>
            <div className="registerContainer">
              <div className="registerSection">
                <div className="quickPlan">
                  <Collapse
                    accordion
                    expandIcon={null}
                    activeKey={activePannel}
                    style={{ paddingRight: 0, paddingLeft: 0 }}
                    onChange={(active) => setActivePannel(active)}
                  >
                    <Panel header="Register" key="register">
                      <div className="formContainer" style={{ paddingTop: "5px" }}>
                        <div className="leftContent">
                          <div className="formControl">
                            <EditableFormInput
                              label={"First Name"}
                              isErrorTextSpacing={true}
                              value={patient?.first_name}
                              handleChange={handleInput("first_name")}
                              required={true}
                              fullWidth={true}
                              isError={validateField("text", patient?.first_name)}
                              enableErrorText={error}
                              helperText={"First Name is Required!"}
                              tabIndex={1}
                            />
                          </div>
                          <div className="formControl">
                            <EditableFormInput
                              isErrorTextSpacing={true}
                              label={"DOB"}
                              value={patient?.date_of_birth}
                              handleChange={handleInput("date_of_birth")}
                              required={true}
                              fullWidth={true}
                              mask={"date"}
                              isError={validateField("date", patient?.date_of_birth)}
                              enableErrorText={error}
                              helperText={"Birthday should be MM/DD/YYYY!"}
                              tabIndex={3}
                            />
                          </div>

                          <div className="formControl">
                            <EditableFormInput
                              isErrorTextSpacing={true}
                              label={"Phone No"}
                              value={patient?.phone}
                              handleChange={handleInput("phone")}
                              required={true}
                              fullWidth={true}
                              mask={"phone"}
                              isError={validateField("phone", patient?.phone)}
                              enableErrorText={error}
                              helperText={"Phone Number is Required"}
                              tabIndex={5}
                            />
                          </div>
                          <div className="formControl">
                            <EditableFormInput
                              isErrorTextSpacing={true}
                              label={"Zip Code"}
                              value={patient?.zipcode}
                              handleChange={handleInput("zipcode")}
                              required={true}
                              fullWidth={true}
                              isError={validateField("text", patient?.zipcode)}
                              enableErrorText={error}
                              helperText={"Zip Code is Required!"}
                              tabIndex={7}
                            />
                          </div>
                          <div className="formControl">
                            <EditableFormInput
                              isErrorTextSpacing={true}
                              label={"Gender"}
                              handleChange={handleChangeOptions("gender")}
                              value={patient?.gender}
                              type={"check"}
                              optionKey={"value"}
                              valueKey={"name"}
                              options={[
                                { value: "male", name: "Male" },
                                { value: "female", name: "Female" },
                              ]}
                              fullWidth={true}
                              required={true}
                              isError={validateField("text", patient?.gender)}
                              enableErrorText={error}
                              helperText={"Gender is Required!"}
                              tabIndex={9}
                            />
                          </div>
                        </div>
                        <div className="rightContent" style={{ paddingRight: 0 }}>
                          <div className="formControl">
                            <EditableFormInput
                              isErrorTextSpacing={true}
                              label={"Last Name"}
                              value={patient?.last_name}
                              handleChange={handleInput("last_name")}
                              required={true}
                              fullWidth={true}
                              tabIndex={2}
                              isError={validateField("text", patient?.last_name)}
                              enableErrorText={error}
                              helperText={"Last Name is Required!"}
                            />
                          </div>
                          <div className="formControl">
                            <EditableFormInput
                              isErrorTextSpacing={true}
                              label={"Referred for"}
                              value={patient?.referral_condition || undefined}
                              handleChange={handleChangeOptions("referral_condition")}
                              required={true}
                              fullWidth={true}
                              tabIndex={4}
                              type={"check"}
                              isError={validateField("text", patient?.referral_condition)}
                              optionKey={"value"}
                              valueKey={"value"}
                              options={conditions || []}
                              enableErrorText={error}
                              helperText={"Diagnosis is required"}
                            />
                          </div>
                          <div
                            className="formControl resourceInfo ins_info"
                            style={{
                              alignItems: "flex-start",
                            }}
                          >
                            <AutoCompleteSearch
                              options={!localLoading && !loadingSearchPCP ? dataPCPRef || [] : []}
                              value={patient?.referral_provider && patient?.referral_provider_name ? patient?.referral_provider_name : undefined}
                              resetValue={resetValue}
                              handlePopulate={handleChangeOptions("referral_provider")}
                              handleSearch={(val) => fetchSearch(val)}
                              title="referring"
                              placeholder="Referred By"
                              actionLabel="Search"
                              keyLabel="provider_name_suffix_address"
                              optionKey="id"
                              backgroundWhite={!patient?.referral_provider ? "red" : "white"}
                              enableErrorText={!patient?.referral_provider ? true : false}
                              helperText={"Referred By is required"}
                              tabIndex={6}
                              fullWidth={true}
                              disableSearchIcon={disableSearchIcon}
                            />
                            {!patient?.referral_provider && (
                              <p className="alert_message">
                                <span>
                                  <RedRequiredCircleSVG /> Search using First Name, Last Name, State
                                </span>
                              </p>
                            )}
                          </div>
                          <div className="formControl">
                            <EditableFormInput
                              isErrorTextSpacing={true}
                              label={"On"}
                              value={patient["referral_date"] || undefined}
                              handleChange={handleChangeOptions("referral_date")}
                              required={true}
                              fullWidth={true}
                              tabIndex={8}
                              type={"date"}
                              isError={validateField("date", patient?.referral_date)}
                              enableErrorText={error}
                              helperText={"On should be MM/DD/YYYY!"}
                            />
                          </div>
                        </div>
                      </div>
                    </Panel>
                    <Panel className="insurancePanel" header="Insurance" key="insurance">
                      <div className="resourceContainer new">
                        <div className="formStepContainer" style={{ marginTop: 0, paddingBottom: 0 }}>
                          <div className="formStepper__content" style={{ margin: 0, padding: 0, borderLeft: "none" }}>
                            <InsuranceDetail valueInsurance={valueInsurance} setPropsInsurance={setPropsInsurance}></InsuranceDetail>
                          </div>
                        </div>
                      </div>
                    </Panel>
                    <Panel header="Notes" key="note">
                      <div className="rightContent" style={{ paddingRight: 0 }}>
                        <div className="formControl">
                          <TextArea
                            placeholder={"Notes"}
                            autoSize={{ minRows: 3 }}
                            style={{
                              borderRadius: 0,
                              backgroundColor: "#f4f7fb",
                            }}
                            onChange={handleChangeOptions("notes")}
                            value={patient?.notes || undefined}
                          />
                        </div>
                      </div>
                    </Panel>
                    {/* TODO */}
                  </Collapse>
                </div>

                <div className="detailContent">
                  <div className="detailInfo">
                    <span style={{ fontSize: 14, color: "#16777F" }}>{image?.name}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <Upload showUploadList={false} {...uploadProps} className="text-right">
                      <button className="common-btn outlined-btn">Upload Image</button>
                    </Upload>
                    <button
                      className="common-btn blue-btn"
                      style={{
                        marginLeft: "0.5rem",
                      }}
                      onClick={onRegister}
                    >
                      Create Record
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ScrollWrapper>
        </div>
      </div>
    </>
  );
};

export default QuickRegister;
